import {Environment, VersionInfo} from "./version-info.model";
import packageJson from "../../package.json";

export const environment = {
	versionInfo: {
		version: packageJson.version,
		buildNumber: '20261105.1',
		environment: Environment.DEVELOP
	} as VersionInfo,

	production: true,
	apiUrl: 'https://dev-api-audit-shop.dekra.com',
	logActionsInConsole: false,
	showFormServiceLogs: false,
	measureFormSubmitTime: false,
	defaultLocale: 'en-US',
	applicationUrl: {
		"en-US": 'https://dev-audit-shop.dekra.com/system/us',
		"pl-PL": 'https://dev-audit-shop.dekra.com/system/pl',
		"nl-NL": 'https://dev-audit-shop.dekra.com/system/nl',
		"es-ES": 'https://dev-audit-shop.dekra.com/system/es',
		"es-MX": 'https://dev-audit-shop.dekra.com/system/mx',
		"en-IN": 'https://dev-audit-shop.dekra.com/system/in',
	},
	baseHref: {
		"en-US": '/system/us/',
		"pl-PL": '/system/pl/',
		"nl-NL": '/system/nl/',
		"es-ES": '/system/es/',
		"es-MX": '/system/mx/',
		"en-IN": '/system/in/',
	},
	realCookies: true,
	cookiesDomain: 'dekra.com',
	tagManagerId: 'GTM-N898BV8',
	displayVersionInMainFrame: true
};
